/**
 * MotoristaTransbordo
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {MotoristaTransbordoCollection} from '@/model/collection/MotoristaTransbordoCollection'

/* TODO: review generated class */
export class MotoristaTransbordo extends Resource {
  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  podeReceber: boolean | null = null
  podeEntregar: boolean | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  /**
   * Gets a instance of a given ID of MotoristaTransbordo
   */
  async getMotoristaTransbordo(id: number) {
    return await Request.get(`/admin/motorista-transbordo/${id}`)
      .name('getMotoristaTransbordo')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of MotoristaTransbordo
   */
  static async listMotoristaTransbordo(params: any) {
    return await Request.get(`/admin/motorista-transbordo`, {params})
      .name('listMotoristaTransbordo')
      .as(MotoristaTransbordoCollection)
      .getData()
  }

  /**
   * Persists a new instance of MotoristaTransbordo. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMotoristaTransbordo() {
    return await Request.post(`/admin/motorista-transbordo`, this)
      .name('persistMotoristaTransbordo')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MotoristaTransbordo to use it in a CSV file
   */
  static async listCsvMotoristaTransbordo(params: any) {
    return await Request.get(`/admin/motorista-transbordo/csv`, {params})
      .name('listCsvMotoristaTransbordo')
      .as(MotoristaTransbordoCollection)
      .getData()
  }
}
